import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminTicketService } from '@/modules/ticket/services/admin-ticket.service'
import { TicketStoreRequestModelInAdmin } from '@/modules/ticket/models/ticket-request.model'

@vservice()
export class TicketCreateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminTicketService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(data: TicketStoreRequestModelInAdmin) {
    return this.service.store(data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}
